import {Method, SimpleAPI} from '../../SimpleAPI'

type TreasuryMinimumEligibleBalanceResponse = {
  minimumEligibleBalanceDollars: number
}

export class TreasuryMinimumEligibleBalance extends SimpleAPI<
  TreasuryMinimumEligibleBalanceResponse,
  any
> {
  revalidate = 60 * 60 * 24 // revalidate every 24 hours
  method = Method.POST

  getPath() {
    return '/treasury/minimum-eligible-balance'
  }

  protected async getMockResponse(): Promise<TreasuryMinimumEligibleBalanceResponse> {
    return {
      minimumEligibleBalanceDollars: 25000,
    }
  }
}
